import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'relativeDate' })
export class RelativeDatePipe implements PipeTransform {
  transform(inputDate: string): string {
    moment.locale('US', {
      calendar: {
        lastDay: '[Yesterday |] LT',
        sameDay: '[Today |] LT',
        nextDay: 'll [|] LT',
        lastWeek: 'll [|] LT',
        nextWeek: 'll [|] LT',
        sameElse: 'll [|] LT'
      }
    });
    return moment(inputDate, 'MM/DD/YYYY hh:mm A').isValid()
      ? moment(inputDate, 'MM/DD/YYYY hh:mm A').calendar()
      : '';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/relative-date.pipe.ts